import React, { memo, useCallback } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';
import { faBroom } from '@fortawesome/free-solid-svg-icons';
import styles from '../chatBot.module.scss';
import { ResetMessage, UpdateOpen } from '../../redux/reducers/chatBotReducer';
import t4bLogo from '../../icons/t4b-logo.svg';
import modalClose from '../../icons/close-window.svg';
import { Button } from './Button';
import { applyStyles } from '../../utils/applyStyles';

export const Header = memo(() => {
  const dispatch = useDispatch();
  const intl = useIntl();

  const onClose = useCallback(() => {
    dispatch(UpdateOpen(false));
  }, []);

  const onReset = useCallback(() => {
    dispatch(ResetMessage());
  }, []);

  return (
    <div className={styles['header']}>
      <div className="text-h4-semibold d-flex align-items-center">
        <img src={t4bLogo} alt="Logo" className="pe-2" />
        <FormattedMessage id="pamm.aiAssistant" />
      </div>
      <div className="d-flex">
        <Button
          text={intl.formatMessage({ id: 'button.clearHistory' })}
          cb={onReset}
          icon={faBroom}
          cls={applyStyles([styles['btn'], styles['btn-clear'], 'pe-2'])}
          type="prompt"
          color="var(--black-400)"
        />
        <button
          type="button"
          onClick={onClose}
          className={styles['btn']}
          title={intl.formatMessage({ id: 'button.closeWindow' })}
        >
          <img src={modalClose} alt="Close" width="20px" className="ps-1" />
        </button>
      </div>
    </div>
  );
});
